/**
 * Utility to convert a Cloudinary URL to optimized responsive formats.
 * Cloudinary allows resizing via URL manipulation.
 * For example: res.cloudinary.com/demo/image/upload/sample.jpg
 * can be transformed to: res.cloudinary.com/demo/image/upload/q_auto,f_auto,w_800,c_limit/sample.jpg
 */
export function getCloudinaryProps(
  url: string, 
  widths = [400, 800, 1200, 1600, 2000], 
  defaultWidth = 1200,
  customSizes = "(max-width: 640px) 100vw, (max-width: 1024px) 80vw, 1200px"
) {
  if (!url || !url.includes('cloudinary.com')) {
    return { src: url };
  }

  const optimizePart = 'q_auto,f_auto';
  
  const getTransformedUrl = (w: number) => {
    // Standardize URL by removing /q_auto/f_auto/ if it exists as separate segments
    let normalized = url.replace('/upload/q_auto/f_auto/', '/upload/');
    if (normalized.includes('/upload/')) {
      return normalized.replace('/upload/', `/upload/${optimizePart},w_${w},c_limit/`);
    }
    return normalized;
  };

  const src = getTransformedUrl(defaultWidth);
  const srcSet = widths.map(w => `${getTransformedUrl(w)} ${w}w`).join(', ');

  return {
    src,
    srcSet,
    sizes: customSizes
  };
}

/**
 * Utility for smaller/fixed-size assets like logos or specific graphics
 */
export function getOptimizedAssetUrl(url: string, width = 300) {
  if (!url || !url.includes('cloudinary.com')) {
    return url;
  }
  let normalized = url.replace('/upload/q_auto/f_auto/', '/upload/');
  if (normalized.includes('/upload/')) {
    return normalized.replace('/upload/', `/upload/q_auto,f_auto,w_${width},c_limit/`);
  }
  return normalized;
}
